import { UpvestPlacedDirectDebit } from './../models/UpvestPlacedDirectDebit';
import { PaginationResponse } from './../responses/PaginationResponse';
import { PlaceOrderModel, UpvestCashBalance, UpvestCashBalanceTransaction, UpvestPaymentAccount, UpvestPlacedWithdrawal } from '../models';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
import { ConfirmUpvestDirectDebitRequest, DirectDebitInitiationRequest, UpvestWithdrawalRequest, UpvestWithdrawalRequestConfirm } from '../requests';
export class UpvestCashBalanceService {
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    constructor() {
        // Initialization code here
    }

    public static async getUpvestCashBalance(upvestAccountGroupId:string): Promise<UpvestCashBalance> {
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestCashBalance(upvestAccountGroupId), this.headers);
            let response: UpvestCashBalance = json.data;
            return response;
        }
        catch (err) {
            throw err;
        }
    }
    public static async getUpvestCashBalancesTransctions(upvestAccountGroupId:string,page:number,per_page:number): Promise<PaginationResponse<UpvestCashBalanceTransaction>> {
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestCashBalanceTransaction(upvestAccountGroupId,page,per_page), this.headers);
            let response:PaginationResponse<UpvestCashBalanceTransaction> = {
                        data:json.data,
                        currentPage:json.meta.current_page,
                        lastPage:json.meta.last_page,
                        total:json.meta.total
                    };
            return response;
        }
        catch (err) {
            throw err;
        }
    }
    public static async getUpvestPaymentAccount(upvestAccountGroupId:string):Promise<UpvestPaymentAccount | null>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestPaymentAccount(upvestAccountGroupId), this.headers);
            let response : UpvestPaymentAccount | null=null;
            if(json && json.data && json.data.length > 0){
                response = json.data[0]
            }
            return response;
        }
        catch (err) {
            throw err;
        }
    }
    public static async initiateDirectDebit(request:DirectDebitInitiationRequest):Promise<UpvestPlacedDirectDebit>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.upvestInitiateDirectdebit(), this.headers,request);
            return json.data;
        }
        catch (err) {
            throw err;
        }
    }
    public static async initiateDirectDebitConfirm(request:ConfirmUpvestDirectDebitRequest):Promise<Boolean>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.upvestInitiateDirectdebitConfirm(), this.headers,request);
            return true;
        }
        catch (err) {
            throw err;
        }
    }
    public static async withdrwal(request:UpvestWithdrawalRequest):Promise<UpvestPlacedWithdrawal>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.upvestWithdrawal(), this.headers,request);
            return json.data;
        }
        catch (err) {
            throw err;
        }
    }
    public static async withdrawalConfirm(request:UpvestWithdrawalRequestConfirm):Promise<Boolean>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.upvestWithdrawalConfirm(), this.headers,request);
            return true;
        }
        catch (err) {
            throw err;
        }
    }
}